import { styled } from '@mui/material';

export const Content = styled('div')({
  height: '100%'
});
